import "../../css/page/newProduct.css";
import React, { useContext, useState } from "react";
import axiosInstance from "../../services/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { endpoint } from "../../utils/API";
import { InputAdornment, InputLabel, TextField } from "@mui/material";
import { CalculateSharp } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { Add, Refresh, Save, TwoWheeler } from "@material-ui/icons";
import { FormContext } from "../../contexts/FormContext";
import { TEMPLATE_PRODUCT } from "../../templates";
import { handleOnKeyDownEnter } from "utils/misc";
import {
  computeMargin,
  computePurchasePrice,
  computeSellingPrice,
  computeSellingPriceWithTaxes,
} from "utils/Forms";

const NewVehicleUsed = () => {
  const navigate = useNavigate();
  const { form, setForm } = useContext(FormContext);
  const [isItemNumberExists, setIsItemNumberExists] = useState(false);

  const updateForm = (e) => {
    const field = {
      name: e.target.name,
      value: e.target.value,
    };

    setForm({
      ...form,
      vehicleUsed: { ...form.vehicleUsed, [field.name]: field.value },
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const newProduct = {
      brand: form.vehicleUsed.brand,
      itemNumber: form.vehicleUsed.itemNumber,
      name: form.vehicleUsed.name,
      description: form.vehicleUsed.description,
      stock: Number.parseInt(form.vehicleUsed.stock),
      purchasePrice: Number.parseFloat(form.vehicleUsed.purchasePrice),
      sellingPrice: Number.parseFloat(form.vehicleUsed.sellingPrice),
      sellingPriceWithTaxes: Number.parseFloat(
        form.vehicleUsed.sellingPriceWithTaxes
      ),
      margin: Number.parseFloat(form.vehicleUsed.margin),
      vatPercentage: Number.parseFloat(form.vehicleUsed.vatPercentage),
      localization: form.vehicleUsed.localization,
    };

    await axiosInstance
      .post(`${endpoint}/vehicles-used`, newProduct)
      .then(() => {
        toast.success("Véhicule ajouté avec succès !");
        setForm({ ...form, vehicleUsed: { ...TEMPLATE_PRODUCT } });
        navigate("/vehiclesUsed");
      })
      .catch(() =>
        toast.error("Une erreur est survenue lors de l'ajout du véhicule !")
      );
  };

  const handleComputePurchasePrice = () => {
    const purchasePrice = computePurchasePrice(form.vehicleUsed);

    setForm({
      ...form,
      vehicleUsed: { ...form.vehicleUsed, purchasePrice: purchasePrice },
    });
  };

  const handleComputeSellingPrice = () => {
    const sellingPrice = computeSellingPrice(form.vehicleUsed);

    setForm({
      ...form,
      vehicleUsed: { ...form.vehicleUsed, sellingPrice: sellingPrice },
    });
  };

  const handleComputeMargin = () => {
    const margin = computeMargin(form.vehicleUsed);

    setForm({
      ...form,
      vehicleUsed: { ...form.vehicleUsed, margin: margin },
    });
  };

  const handleComputeSellingPriceWithTaxes = () => {
    const sellingPriceWithTaxes = computeSellingPriceWithTaxes(
      form.vehicleUsed
    );

    setForm({
      ...form,
      vehicleUsed: {
        ...form.vehicleUsed,
        sellingPriceWithTaxes: sellingPriceWithTaxes,
      },
    });
  };

  const resetForm = () => {
    setForm({ ...form, vehicleUsed: { ...TEMPLATE_PRODUCT } });
  };

  const checkItemNumberExists = async () => {
    setIsItemNumberExists(false);
    const itemNumber = form.vehicleUsed.itemNumber;

    if (itemNumber) {
      await axiosInstance
        .get(`${endpoint}/vehicles-used/find/${itemNumber}`)
        .then((response) => {
          if (response.data.result) {
            setIsItemNumberExists(true);
          }
        })
        .catch(() => {});
    }
  };

  return (
    <div className="content">
      <div className="above-table">
        <div className="title-refresh-container">
          <h1 className="title">Nouveau véhicule d'occasion</h1>
          <button onClick={resetForm} className="refresh-button">
            <div className="homeLinkIcons">
              <Refresh />
            </div>
          </button>
        </div>
      </div>
      <form
        className="addProductForm"
        onSubmit={onSubmit}
        onKeyDown={handleOnKeyDownEnter}
      >
        <div className="addProductItem">
          <InputLabel htmlFor="brand">Marque</InputLabel>
          <TextField
            type="text"
            value={form.vehicleUsed.brand}
            name="brand"
            onChange={updateForm}
            placeholder="BIR"
            inputProps={{
              className: "upperCase",
            }}
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="brand">Référence</InputLabel>
          <TextField
            type="text"
            value={form.vehicleUsed.itemNumber}
            name="itemNumber"
            onChange={updateForm}
            placeholder="motul-100000"
            onBlur={checkItemNumberExists}
            error={isItemNumberExists}
            helperText={
              isItemNumberExists
                ? "Cette référence a déjà été assignée !"
                : "Référence disponible !"
            }
            inputProps={{
              className: "upperCase",
            }}
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="name" required>
            Nom
          </InputLabel>
          <TextField
            type="text"
            value={form.vehicleUsed.name}
            name="name"
            onChange={updateForm}
            placeholder="Apple Airpods"
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="description">Description</InputLabel>
          <TextField
            type="text"
            value={form.vehicleUsed.description}
            name="description"
            onChange={updateForm}
            placeholder="Écouteurs de la marque Apple"
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="stock" required>
            Quantité en stock
          </InputLabel>
          <TextField
            type="number"
            value={form.vehicleUsed.stock}
            name="stock"
            onChange={updateForm}
            required
          />
        </div>

        <div className="addProductItem">
          <InputLabel htmlFor="purchasePrice" required>
            Prix d'achat unitaire
          </InputLabel>
          <TextField
            inputProps={{ step: "0.01" }}
            type="number"
            value={form.vehicleUsed.purchasePrice}
            name="purchasePrice"
            onChange={updateForm}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton onClick={handleComputePurchasePrice}>
                    <CalculateSharp />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="sellingPrice" required>
            Prix de vente unitaire
          </InputLabel>
          <TextField
            inputProps={{ step: "0.01" }}
            type="number"
            value={form.vehicleUsed.sellingPrice}
            name="sellingPrice"
            onChange={updateForm}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton onClick={handleComputeSellingPrice}>
                    <CalculateSharp />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="margin" required>
            Marge de base (%)
          </InputLabel>
          <TextField
            inputProps={{ step: "0.01" }}
            type="number"
            value={form.vehicleUsed.margin}
            name="margin"
            onChange={updateForm}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton onClick={handleComputeMargin}>
                    <CalculateSharp />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="vatPercentage">Taux T.V.A. (%)</InputLabel>
          <TextField
            inputProps={{ step: "0.01" }}
            type="number"
            value={form.vehicleUsed.vatPercentage}
            name="vatPercentage"
            onChange={updateForm}
            placeholder="21"
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="sellingPriceWithTaxes" required>
            Prix de vente unitaire TTC
          </InputLabel>
          <TextField
            inputProps={{ step: "0.01" }}
            type="number"
            value={form.vehicleUsed.sellingPriceWithTaxes}
            name="sellingPriceWithTaxes"
            onChange={updateForm}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton onClick={handleComputeSellingPriceWithTaxes}>
                    <CalculateSharp />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
        </div>
        <div className="addProductItem">
          <InputLabel htmlFor="localization">Localisation</InputLabel>
          <TextField
            type="text"
            value={form.vehicleUsed.localization}
            name="localization"
            onChange={updateForm}
            placeholder="H00103"
            inputProps={{
              className: "upperCase",
            }}
          />
        </div>
        <button type="submit" className="create-button">
          <div className="homeLinkIcons">
            <Add />
            <TwoWheeler />
          </div>
          <span>Véhicule d'occasion</span>
        </button>
      </form>
    </div>
  );
};

export default NewVehicleUsed;
